import { useEffect } from 'react';

const BASE_TITLE = 'Apex Precitech';
const BASE_DESC  = 'Precision measurement and setting instruments for textile spinning machinery. Trusted by 5,000+ mills across 18+ countries since 1996.';
const BASE_URL   = 'https://www.apexprecitech.com';

/* ── Inject or replace a <script type="application/ld+json"> ── */
function injectSchema(id, schema) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id   = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(schema);
}

function removeSchema(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.name = name;
    document.head.appendChild(el);
  }
  el.content = content;
}

/* ── Organisation schema — injected once, never removed ── */
const ORG_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Apex Precitech',
  url: BASE_URL,
  logo: `${BASE_URL}/images/logo.png`,
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+91-98430-35014',
    contactType: 'sales',
    areaServed: 'Worldwide',
    availableLanguage: 'English',
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Coimbatore',
    addressRegion: 'Tamil Nadu',
    addressCountry: 'IN',
  },
  sameAs: ['https://apexprecitech.wordpress.com/'],
};

/* ── Main SEO component ── */
export default function SEO({ title, description, product }) {
  const fullTitle = title ? `${title} — ${BASE_TITLE}` : `${BASE_TITLE} — Precision Instruments for Textile Spinning`;
  const desc      = description || BASE_DESC;

  useEffect(() => {
    // Page title
    document.title = fullTitle;

    // Meta description
    setMeta('description', desc);

    // Canonical (best effort without server)
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = window.location.href.split('?')[0];

    // Organisation schema — inject once
    injectSchema('schema-org', ORG_SCHEMA);

    // Product schema — only when a product is passed
    if (product) {
      injectSchema('schema-product', {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: product.name,
        description: product.desc,
        brand: { '@type': 'Brand', name: 'Apex Precitech' },
        manufacturer: {
          '@type': 'Organization',
          name: 'Apex Precitech',
          address: { '@type': 'PostalAddress', addressLocality: 'Coimbatore', addressCountry: 'IN' },
        },
        offers: {
          '@type': 'Offer',
          availability: 'https://schema.org/InStock',
          priceCurrency: 'INR',
          seller: { '@type': 'Organization', name: 'Apex Precitech' },
        },
      });
    } else {
      removeSchema('schema-product');
    }
  }, [fullTitle, desc, product]);

  return null;  // renders nothing — side-effects only
}
